import { useTranslation } from 'react-i18next';

import ContactIcon from './ContactIcon/ContactIcon';
import classes from './ContactInfo.module.css';

const ContactInfo = (props)=>{
    const {t} = useTranslation();

    return (
        <div className={classes.ContactInfo}>
            <h3>{t('contact.info.title')}</h3>
            <p>{t('contact.info.subtitle')}</p>
            <ul className={classes.ContactIcons}>
                <ContactIcon icon={<i className="fa-solid fa-location-dot"></i>} text="Elafcorp" link="#"/>
                <ContactIcon icon={<i className="fa-regular fa-envelope"></i>} text="Info@redtaxi24.com" link="mailto:info@redtaxi24.com"/>
                <ContactIcon icon={<i className="fa-brands fa-facebook-f"></i> } text="elafcorp" link="https://www.facebook.com/redridetaxi"/>
            </ul>
        </div>
    );
}

export default ContactInfo;